import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Snackbar from "@material-ui/core/Snackbar";
import React, { Component } from "react";
import { connect } from "react-redux";

import { mapActionsToProps } from "./../redux/notification";
import SnackbarContentWrapper from "./SnackbarContentWrapper";

class Notification extends Component {
  handleClose() {
    this.props.closeSnackbar && this.props.closeSnackbar();
  }
  handleSubmit() {
    this.props.submitCall && this.props.submitCall();
  }
  render() {
    const { notification } = this.props;
    return (
      <Snackbar
        open={notification.open}
        anchorOrigin={notification.anchorOrigin}
        // autoHideDuration={2000}
        action={[
          <React.Fragment>
            <IconButton
              aria-label="Done"
              size="small"
              onClick={this.handleClose.bind(this)}>
              <Icon style={{ color: "#fff" }}>done</Icon>
            </IconButton>
            <IconButton
              aria-label="Cancel"
              size="small"
              onClick={this.handleClose.bind(this)}>
              <Icon style={{ color: "#fff" }}>clear</Icon>
            </IconButton>
          </React.Fragment>,
        ]}>
        <SnackbarContentWrapper
          variant={notification.variant}
          message={notification.message}
          action={[
            <React.Fragment>
              <IconButton
                aria-label="Done"
                size="small"
                onClick={this.handleClose.bind(this)}>
                <Icon style={{ color: "#fff" }}>done</Icon>
              </IconButton>
              <IconButton
                aria-label="Cancel"
                size="small"
                onClick={this.handleClose.bind(this)}>
                <Icon style={{ color: "#fff" }}>clear</Icon>
              </IconButton>
            </React.Fragment>,
          ]}
        />
      </Snackbar>
    );
  }
}

const mapStateToProps = (state) => ({
  notification: state.notification.notification,
});

export default connect(mapStateToProps, mapActionsToProps)(Notification);
